import { IconName } from '@fortawesome/fontawesome-svg-core';
export interface VerticalTabNavigationProps {
  data: NavigationProps[];
  activeRoute?: string;
  content?: React.JSX.Element;
  goToRoute?: (url: string) => void;
  disableNavigation?: boolean;
  customClass?: string;
  source: NavigationSource;
}

export interface NavigationProps {
  label: string;
  url: string;
  target?: string;
  iconName?: IconName;
}
export interface VerticalTabNavigationItemProps extends NavigationProps {
  activeRoute?: string;
  source: NavigationSource;
}

export interface NavigationLink {
  text: string;
  url: string;
}

export enum NavigationSource {
  ACCOUNT = 'account',
  CONTENT = 'content',
}
